/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import Moment from 'react-moment';

import Loading from 'components/Loading/Loading';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';

import type Form from '../../../../../../forms/_.extend';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  project: Object,
  projectDetailsStore: Object,
  form: Form,
};

@translate()
@inject('projectDetailsStore')
@observer
export default class EndProjectForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { project, form, projectDetailsStore }: TypeProps = this.props;

    const projectDetails: Object = project.trading_account ? project : projectDetailsStore.details;

    const getChildData: Function = (child: string, val: string) => {
      return typeof projectDetails[child] === 'undefined' ? null : projectDetails[child][val];
    };

    const startDate: * = <Moment date={projectDetails.start_date} format="MMMM DD, YYYY" />;
    const endDate: * = <Moment date={projectDetails.end_date} format="MMMM DD, YYYY" />;

    const projectInfo: Array<*> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:projects.labels.code'), projectDetails.code],
      [t('general:projects.labels.name'), projectDetails.name],
      [t('general:projects.labels.start_date'), startDate],
      [t('general:projects.labels.end_date'), endDate],
      [t('general:assets.abbrs.number_in_use'), projectDetails.assets && projectDetails.assets.all],
      [
        t('general:cost_centers.abbrs.number_in_use'),
        projectDetails.cost_centres && projectDetails.cost_centres.length,
      ],
      [
        t('general:engineers.abbrs.number_assigned'),
        projectDetails.engineers && projectDetails.engineers.length,
      ],
    ];

    if (!projectDetailsStore.details.trading_account) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:projects.labels.details')}
          >
            <ActionDrawerTable data={projectInfo} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.reasons.why_end')}
          >
            <ElectroSelectWithOther
              field={form.$('endProjectForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.end_project')} />
      </React.Fragment>
    );
  }
}
